import { EventMap } from './eventMapping';
import { GA4Provider } from './provider/GA4Provider';
import { GoogleAdsProvider } from './provider/googleAdsProvider';

// 统一从这里收发：为后续 MetaAds 等预留 hook
export class Tracker {
  static track(
    eventKey: keyof typeof EventMap,
    params: Record<string, any> = {}
  ) {
    const config = EventMap[eventKey];

    if (!config) {
      console.warn(`[Tracker] Unknown event key: ${eventKey}`);
      return;
    }

    for (const provider of config.providers) {
      switch (provider) {
        case 'ga4':
          if (config.ga4Event) {
            GA4Provider.send(config.ga4Event, params);
          }
          break;
        case 'googleAds':
          if (config.googleAdsEvent && config.adsSendTo) {
            GoogleAdsProvider.send(
              config.googleAdsEvent,
              config.adsSendTo,
              params
            );
          }
          break;
      }
    }
  }
}
